import styled from 'styled-components';
import { animated } from 'react-spring';

import { breakpoints, colors, spacing } from '../../constants';

export const SubHeader = styled(animated.h5)`
    padding: ${spacing.md} 0;
    font-weight: 300;
    font-size: 15px;
    line-height: 1.6;
    color: ${colors.greenDark};

    @media (${breakpoints.mediumMin}) {
        line-height: 1.3;
    }

    @media (${breakpoints.largeMin}) {
        font-size: 25px;
    }
`;
